"use strict";
/*
 * Created on Wed Jan 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var AdtFlag_1 = require("../../core/model/AdtFlag");
/**
 * Product flag is related to {@link WindowItem} validation
 *
 * @author JMt
 * @author ZSt refactored
 */
// tslint:disable:max-classes-per-file


var WindowItemWarningFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(WindowItemWarningFlag, _AdtFlag_1$AdtFlag);

  // tslint:disable-next-line
  function WindowItemWarningFlag(infoMessage, messageVars) {
    var _this;

    _classCallCheck(this, WindowItemWarningFlag);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemWarningFlag).call(this));
    _this.infoMessage = infoMessage;
    _this.messageVars = messageVars;
    return _this;
  }

  _createClass(WindowItemWarningFlag, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }], [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(WindowItemWarningFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(WindowItemWarningFlag, data);
    }
  }]);

  return WindowItemWarningFlag;
}(AdtFlag_1.AdtFlag);

exports.WindowItemWarningFlag = WindowItemWarningFlag;
WindowItemWarningFlag.TAG = '__WindowItemFlag__';
/**
 * DirectDeliverySites not set (DirectDelivery == true)
 */

var ValueMissingDirectDeliverySites =
/*#__PURE__*/
function (_WindowItemWarningFla) {
  _inherits(ValueMissingDirectDeliverySites, _WindowItemWarningFla);

  function ValueMissingDirectDeliverySites() {
    _classCallCheck(this, ValueMissingDirectDeliverySites);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueMissingDirectDeliverySites).apply(this, arguments));
  }

  return ValueMissingDirectDeliverySites;
}(WindowItemWarningFlag);

exports.ValueMissingDirectDeliverySites = ValueMissingDirectDeliverySites;
ValueMissingDirectDeliverySites.TAG = WindowItemWarningFlag.register(ValueMissingDirectDeliverySites);
/**
 * One of mandatory posAttributes is missing
 */

var ValueMissingPosAttributes =
/*#__PURE__*/
function (_WindowItemWarningFla2) {
  _inherits(ValueMissingPosAttributes, _WindowItemWarningFla2);

  function ValueMissingPosAttributes() {
    _classCallCheck(this, ValueMissingPosAttributes);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueMissingPosAttributes).apply(this, arguments));
  }

  return ValueMissingPosAttributes;
}(WindowItemWarningFlag);

exports.ValueMissingPosAttributes = ValueMissingPosAttributes;
ValueMissingPosAttributes.TAG = WindowItemWarningFlag.register(ValueMissingPosAttributes);
/** LOG-4792 - FC approval is needed on window */

var FcApprovalNeeded =
/*#__PURE__*/
function (_WindowItemWarningFla3) {
  _inherits(FcApprovalNeeded, _WindowItemWarningFla3);

  function FcApprovalNeeded() {
    _classCallCheck(this, FcApprovalNeeded);

    return _possibleConstructorReturn(this, _getPrototypeOf(FcApprovalNeeded).apply(this, arguments));
  }

  return FcApprovalNeeded;
}(WindowItemWarningFlag);

exports.FcApprovalNeeded = FcApprovalNeeded;
FcApprovalNeeded.TAG = WindowItemWarningFlag.register(FcApprovalNeeded);
/**
 * Flag indicating the product is not in window portfolio (product category)
 */

var ProductInDifferentCategory =
/*#__PURE__*/
function (_WindowItemWarningFla4) {
  _inherits(ProductInDifferentCategory, _WindowItemWarningFla4);

  function ProductInDifferentCategory() {
    _classCallCheck(this, ProductInDifferentCategory);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductInDifferentCategory).apply(this, arguments));
  }

  return ProductInDifferentCategory;
}(WindowItemWarningFlag);

exports.ProductInDifferentCategory = ProductInDifferentCategory;
ProductInDifferentCategory.TAG = WindowItemWarningFlag.register(ProductInDifferentCategory);
/**
 * Product is inactive
 */

var ProductInactive =
/*#__PURE__*/
function (_WindowItemWarningFla5) {
  _inherits(ProductInactive, _WindowItemWarningFla5);

  function ProductInactive() {
    _classCallCheck(this, ProductInactive);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductInactive).apply(this, arguments));
  }

  return ProductInactive;
}(WindowItemWarningFlag);

exports.ProductInactive = ProductInactive;
ProductInactive.TAG = WindowItemWarningFlag.register(ProductInactive);
/**
 * Main product is the same as the substitute
 */

var ProductMainIsSubstitute =
/*#__PURE__*/
function (_WindowItemWarningFla6) {
  _inherits(ProductMainIsSubstitute, _WindowItemWarningFla6);

  function ProductMainIsSubstitute() {
    _classCallCheck(this, ProductMainIsSubstitute);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductMainIsSubstitute).apply(this, arguments));
  }

  return ProductMainIsSubstitute;
}(WindowItemWarningFlag);

exports.ProductMainIsSubstitute = ProductMainIsSubstitute;
ProductMainIsSubstitute.TAG = WindowItemWarningFlag.register(ProductMainIsSubstitute);
/**
 * Multiple promos for the same product, on the same site, at the same time
 */

var ProductOverlappingPromo =
/*#__PURE__*/
function (_WindowItemWarningFla7) {
  _inherits(ProductOverlappingPromo, _WindowItemWarningFla7);

  function ProductOverlappingPromo() {
    _classCallCheck(this, ProductOverlappingPromo);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductOverlappingPromo).apply(this, arguments));
  }

  return ProductOverlappingPromo;
}(WindowItemWarningFlag);

exports.ProductOverlappingPromo = ProductOverlappingPromo;
ProductOverlappingPromo.TAG = WindowItemWarningFlag.register(ProductOverlappingPromo);
/**
 * Product is in one promotion multiple times
 */

var DuplicitProductInOnePromotion =
/*#__PURE__*/
function (_WindowItemWarningFla8) {
  _inherits(DuplicitProductInOnePromotion, _WindowItemWarningFla8);

  function DuplicitProductInOnePromotion() {
    _classCallCheck(this, DuplicitProductInOnePromotion);

    return _possibleConstructorReturn(this, _getPrototypeOf(DuplicitProductInOnePromotion).apply(this, arguments));
  }

  return DuplicitProductInOnePromotion;
}(WindowItemWarningFlag);

exports.DuplicitProductInOnePromotion = DuplicitProductInOnePromotion;
DuplicitProductInOnePromotion.TAG = WindowItemWarningFlag.register(DuplicitProductInOnePromotion);
/**
 * Promo volume forecast was not computed
 */

var ProductPromoVolumeNotComputed =
/*#__PURE__*/
function (_WindowItemWarningFla9) {
  _inherits(ProductPromoVolumeNotComputed, _WindowItemWarningFla9);

  function ProductPromoVolumeNotComputed() {
    _classCallCheck(this, ProductPromoVolumeNotComputed);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPromoVolumeNotComputed).apply(this, arguments));
  }

  return ProductPromoVolumeNotComputed;
}(WindowItemWarningFlag);

exports.ProductPromoVolumeNotComputed = ProductPromoVolumeNotComputed;
ProductPromoVolumeNotComputed.TAG = WindowItemWarningFlag.register(ProductPromoVolumeNotComputed);

var SiteNotFound =
/*#__PURE__*/
function (_WindowItemWarningFla10) {
  _inherits(SiteNotFound, _WindowItemWarningFla10);

  function SiteNotFound() {
    _classCallCheck(this, SiteNotFound);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteNotFound).apply(this, arguments));
  }

  return SiteNotFound;
}(WindowItemWarningFlag);

exports.SiteNotFound = SiteNotFound;
SiteNotFound.TAG = WindowItemWarningFlag.register(SiteNotFound);

var SiteAvailabilityGap =
/*#__PURE__*/
function (_WindowItemWarningFla11) {
  _inherits(SiteAvailabilityGap, _WindowItemWarningFla11);

  function SiteAvailabilityGap() {
    _classCallCheck(this, SiteAvailabilityGap);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteAvailabilityGap).apply(this, arguments));
  }

  return SiteAvailabilityGap;
}(WindowItemWarningFlag);

exports.SiteAvailabilityGap = SiteAvailabilityGap;
SiteAvailabilityGap.TAG = WindowItemWarningFlag.register(SiteAvailabilityGap);

var SiteHasProductNA =
/*#__PURE__*/
function (_WindowItemWarningFla12) {
  _inherits(SiteHasProductNA, _WindowItemWarningFla12);

  function SiteHasProductNA() {
    _classCallCheck(this, SiteHasProductNA);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteHasProductNA).apply(this, arguments));
  }

  return SiteHasProductNA;
}(WindowItemWarningFlag);

exports.SiteHasProductNA = SiteHasProductNA;
SiteHasProductNA.TAG = WindowItemWarningFlag.register(SiteHasProductNA);
/**
 * There's no overlap between the item GOS and promo GOS
 */

var ItemPromotionGosNoOverlap =
/*#__PURE__*/
function (_WindowItemWarningFla13) {
  _inherits(ItemPromotionGosNoOverlap, _WindowItemWarningFla13);

  function ItemPromotionGosNoOverlap() {
    _classCallCheck(this, ItemPromotionGosNoOverlap);

    return _possibleConstructorReturn(this, _getPrototypeOf(ItemPromotionGosNoOverlap).apply(this, arguments));
  }

  return ItemPromotionGosNoOverlap;
}(WindowItemWarningFlag);

exports.ItemPromotionGosNoOverlap = ItemPromotionGosNoOverlap;
ItemPromotionGosNoOverlap.TAG = WindowItemWarningFlag.register(ItemPromotionGosNoOverlap);
/**
 * There's no overlap between the direct delivery GOS and item GOS
 */

var DirectDeliveryPromotionGosNoOverlap =
/*#__PURE__*/
function (_WindowItemWarningFla14) {
  _inherits(DirectDeliveryPromotionGosNoOverlap, _WindowItemWarningFla14);

  function DirectDeliveryPromotionGosNoOverlap() {
    _classCallCheck(this, DirectDeliveryPromotionGosNoOverlap);

    return _possibleConstructorReturn(this, _getPrototypeOf(DirectDeliveryPromotionGosNoOverlap).apply(this, arguments));
  }

  return DirectDeliveryPromotionGosNoOverlap;
}(WindowItemWarningFlag);

exports.DirectDeliveryPromotionGosNoOverlap = DirectDeliveryPromotionGosNoOverlap;
DirectDeliveryPromotionGosNoOverlap.TAG = WindowItemWarningFlag.register(DirectDeliveryPromotionGosNoOverlap);
/**
 * Promo and system volume are over threshold
 */

var VolumeThreshold =
/*#__PURE__*/
function (_WindowItemWarningFla15) {
  _inherits(VolumeThreshold, _WindowItemWarningFla15);

  function VolumeThreshold() {
    _classCallCheck(this, VolumeThreshold);

    return _possibleConstructorReturn(this, _getPrototypeOf(VolumeThreshold).apply(this, arguments));
  }

  return VolumeThreshold;
}(WindowItemWarningFlag);

exports.VolumeThreshold = VolumeThreshold;
VolumeThreshold.TAG = WindowItemWarningFlag.register(VolumeThreshold);
/**
 * Unit back discount w/o setting Unit back discount realization and Supplier for invoice
 */

var ProductReturnableIncomplete =
/*#__PURE__*/
function (_WindowItemWarningFla16) {
  _inherits(ProductReturnableIncomplete, _WindowItemWarningFla16);

  function ProductReturnableIncomplete() {
    _classCallCheck(this, ProductReturnableIncomplete);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductReturnableIncomplete).apply(this, arguments));
  }

  return ProductReturnableIncomplete;
}(WindowItemWarningFlag);

exports.ProductReturnableIncomplete = ProductReturnableIncomplete;
ProductReturnableIncomplete.TAG = ProductReturnableIncomplete.register(ProductReturnableIncomplete);
/**
 * There's incomplete set of fields for distribution model
 */

var ProductDistributionModelIncomplete =
/*#__PURE__*/
function (_WindowItemWarningFla17) {
  _inherits(ProductDistributionModelIncomplete, _WindowItemWarningFla17);

  function ProductDistributionModelIncomplete() {
    _classCallCheck(this, ProductDistributionModelIncomplete);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductDistributionModelIncomplete).apply(this, arguments));
  }

  return ProductDistributionModelIncomplete;
}(WindowItemWarningFlag);

exports.ProductDistributionModelIncomplete = ProductDistributionModelIncomplete;
ProductDistributionModelIncomplete.TAG = ProductDistributionModelIncomplete.register(ProductDistributionModelIncomplete);
/**
 * There's incomplete set of fields for pos distribution model
 */

var ProductPosDistributionModelIncomplete =
/*#__PURE__*/
function (_WindowItemWarningFla18) {
  _inherits(ProductPosDistributionModelIncomplete, _WindowItemWarningFla18);

  function ProductPosDistributionModelIncomplete() {
    _classCallCheck(this, ProductPosDistributionModelIncomplete);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPosDistributionModelIncomplete).apply(this, arguments));
  }

  return ProductPosDistributionModelIncomplete;
}(WindowItemWarningFlag);

exports.ProductPosDistributionModelIncomplete = ProductPosDistributionModelIncomplete;
ProductPosDistributionModelIncomplete.TAG = ProductPosDistributionModelIncomplete.register(ProductPosDistributionModelIncomplete);
/**
 * Volume wrong rounding
 */

var VolumeWrongRounding =
/*#__PURE__*/
function (_WindowItemWarningFla19) {
  _inherits(VolumeWrongRounding, _WindowItemWarningFla19);

  function VolumeWrongRounding() {
    _classCallCheck(this, VolumeWrongRounding);

    return _possibleConstructorReturn(this, _getPrototypeOf(VolumeWrongRounding).apply(this, arguments));
  }

  return VolumeWrongRounding;
}(WindowItemWarningFlag);

exports.VolumeWrongRounding = VolumeWrongRounding;
VolumeWrongRounding.TAG = VolumeWrongRounding.register(VolumeWrongRounding);

var PromoPriceZeroOrNegative =
/*#__PURE__*/
function (_WindowItemWarningFla20) {
  _inherits(PromoPriceZeroOrNegative, _WindowItemWarningFla20);

  function PromoPriceZeroOrNegative() {
    _classCallCheck(this, PromoPriceZeroOrNegative);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoPriceZeroOrNegative).apply(this, arguments));
  }

  return PromoPriceZeroOrNegative;
}(WindowItemWarningFlag);

exports.PromoPriceZeroOrNegative = PromoPriceZeroOrNegative;
PromoPriceZeroOrNegative.TAG = PromoPriceZeroOrNegative.register(PromoPriceZeroOrNegative);

var SystemVolumeFailedToCompute =
/*#__PURE__*/
function (_WindowItemWarningFla21) {
  _inherits(SystemVolumeFailedToCompute, _WindowItemWarningFla21);

  function SystemVolumeFailedToCompute() {
    _classCallCheck(this, SystemVolumeFailedToCompute);

    return _possibleConstructorReturn(this, _getPrototypeOf(SystemVolumeFailedToCompute).apply(this, arguments));
  }

  return SystemVolumeFailedToCompute;
}(WindowItemWarningFlag);

exports.SystemVolumeFailedToCompute = SystemVolumeFailedToCompute;
SystemVolumeFailedToCompute.TAG = SystemVolumeFailedToCompute.register(SystemVolumeFailedToCompute);
/**
 * GoS of e-commerce item differs from GoS of e-commerce promotion.
 */

var EcommerceItemGosDiffersFromPromotionGosFlag =
/*#__PURE__*/
function (_WindowItemWarningFla22) {
  _inherits(EcommerceItemGosDiffersFromPromotionGosFlag, _WindowItemWarningFla22);

  function EcommerceItemGosDiffersFromPromotionGosFlag() {
    _classCallCheck(this, EcommerceItemGosDiffersFromPromotionGosFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(EcommerceItemGosDiffersFromPromotionGosFlag).apply(this, arguments));
  }

  return EcommerceItemGosDiffersFromPromotionGosFlag;
}(WindowItemWarningFlag);

exports.EcommerceItemGosDiffersFromPromotionGosFlag = EcommerceItemGosDiffersFromPromotionGosFlag;
EcommerceItemGosDiffersFromPromotionGosFlag.TAG = WindowItemWarningFlag.register(EcommerceItemGosDiffersFromPromotionGosFlag);
/**
 * Warning flag for missing {@link MemberCredits} required values when MemberCredits.enabled is set to true.
 */

var ValueMissingMemberCreditsFlag =
/*#__PURE__*/
function (_WindowItemWarningFla23) {
  _inherits(ValueMissingMemberCreditsFlag, _WindowItemWarningFla23);

  function ValueMissingMemberCreditsFlag() {
    _classCallCheck(this, ValueMissingMemberCreditsFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueMissingMemberCreditsFlag).apply(this, arguments));
  }

  return ValueMissingMemberCreditsFlag;
}(WindowItemWarningFlag);

exports.ValueMissingMemberCreditsFlag = ValueMissingMemberCreditsFlag;
ValueMissingMemberCreditsFlag.TAG = WindowItemWarningFlag.register(ValueMissingMemberCreditsFlag);
/**
 * <p>
 * Named groups of window item warning flags to support business case writen in drive document
 * </p>
 * <a href="https://docs.google.com/spreadsheets/d/1RNMrxVqacxTbjkQqE5Ob-Nlh_obIxe0o45C_ydWcxCg/edit#gid=0&fvid=726127244">
 *     Validace oken, items, promotions - flags, errors</a>
 */

var WindowItemWarningFlagGroups = function WindowItemWarningFlagGroups() {
  _classCallCheck(this, WindowItemWarningFlagGroups);
};

exports.WindowItemWarningFlagGroups = WindowItemWarningFlagGroups;
/**
 * Business case for "Can Save Window Session"
 */
// TODO ZSt inverse flags set is more secure

WindowItemWarningFlagGroups.FLAGS_REJECTING_SAVE_SESSION = immutable_1.Set.of(ValueMissingDirectDeliverySites, ValueMissingPosAttributes, ValueMissingMemberCreditsFlag, ProductInDifferentCategory, ProductInactive, ProductMainIsSubstitute, ProductOverlappingPromo, ProductPromoVolumeNotComputed, SiteNotFound, ItemPromotionGosNoOverlap, DirectDeliveryPromotionGosNoOverlap, ProductReturnableIncomplete, ProductDistributionModelIncomplete, ProductPosDistributionModelIncomplete, VolumeWrongRounding, PromoPriceZeroOrNegative);
WindowItemWarningFlagGroups.FLAGS_REJECTING_COPY = immutable_1.Set.of(ProductInDifferentCategory, ProductInactive, ProductOverlappingPromo, DuplicitProductInOnePromotion);